import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default props => (
  <SvgIcon {...props} viewBox="0 0 166 197.4">
    <path
      className="st0"
      d="M153.3,49l-3.6,1l6.8,20.3l-49.4-3.6l-19.9,67.8c1,0.2,2,0.3,3,0.5c1.8-3.8,3.7-6.8,5.3-9
	c2.9-4.1,5.7-6.7,6.4-7.3c2.7-2.6,5.3-4.4,7-5.5c1.8-1.2,4.9-3.1,9.4-4.7c2.6-0.9,4.8-1.3,6.4-1.6c0.9,1.7,2.1,4.3,2.7,7.8
	c0.2,1.1,0.8,4.9-0.3,9.6c-0.9,4.1-2.5,6.9-4,9.3c-1.2,2-2.3,3.6-3.2,4.8l0.2,0l18.3,1.7l21.7-70.7L153.3,49L153.3,49z"
    />
    <path
      className="st0"
      d="M39.8,96.3c-2.1,0.2-3.8,1.2-4.6,1.9c-0.9,0.9-1.5,2-1.5,2l0,0c-0.3,0.6-0.6,1.2-0.7,2.1
	c-1.8,8.2-0.9,18.2-0.9,18.2c0.6,5.1,1,8.9,1.4,12.2l0,0c0.4,2.8,1,5.8,1.9,9c0.4,1.3,1.1,4.1,2.4,7.5c1.1,2.9,2.7,6.7,4.9,10.9
	c0.4-0.8,1.6-2.6,3.8-3.7c2.9-1.5,5.6-0.5,6.2-0.3c0.8-8.7,0.8-15.4,0.7-19.9c-0.1-3.1-0.3-5.5-0.3-6.2c-0.4-5.2-1-9.5-1.6-12.7
	c-2.1-12.1-3.3-18.7-7.2-20.5C43.3,96.5,41.6,96.1,39.8,96.3L39.8,96.3z"
    />
    <path
      className="st0"
      d="M61.2,174.9c0.1,2.9-1.7,4.9-2.2,5.5c-0.6,0.6-2.7,2.5-5.6,2.4c-3.8-0.1-7.9-3.3-7.9-7.9c0-4.4,3.5-7.9,7.9-7.9
	C58,166.9,61.2,171.1,61.2,174.9z"
    />
    <path
      className="st0"
      d="M96.4,139.8c-5-0.8-9.8,2.9-15.1,7c-1,0.8-5.2,4.2-10.2,10.1c-3.3,3.9-5.6,7.5-7.2,10.1
	c0.7,0.5,2.1,1.8,2.9,3.9c0.7,1.7,0.7,3.1,0.7,4c6.9-1.4,12.3-3.6,16-5.3c8.7-4.1,13.1-8.4,14.1-9.5c2.7-2.7,6.4-6.7,6.4-11.7
	c0-1-0.1-3.2-1.8-5.3C102,142.8,99.8,140.3,96.4,139.8L96.4,139.8z"
    />
    <path
      className="st0"
      d="M122,114c-1.5,0.2-2.8,0.5-4.1,0.8c-12.9,3.5-19.9,15.4-22.6,20.8c3.2-1,6.6-0.3,9,1.8c3,2.7,2.8,6.5,2.7,7
	c2.1-1.5,4.8-3.6,7.6-6.5c2.3-2.4,4.2-4.3,5.9-7.5c1.1-2.1,2.8-5.5,2.7-10C123.2,117.6,122.5,115.4,122,114L122,114z"
    />
    <path
      className="st0"
      d="M5.7,142.5c0,0,4.7,14.2,9.2,32.4c1.5,5.9,2.9,13.4,3.5,22.5c11.6-0.6,23.4,0.2,35,0.2c7.5,0,15,0.1,22.5,0.2
	c0-0.8,0-1.6,0-2.4c-0.1-5.2-0.4-10.2-0.8-15c-0.6,0-1.3,0-1.9-0.1c-1.2,0-1.8-0.1-2-0.1c-1.3-0.1-4-0.2-4-0.2c-0.2,0-0.4,0-0.6,0
	c0,0,0,0-0.1,0c-0.9,1.9-2.2,3.3-2.8,3.8c-1,0.9-4.7,3.9-10,3.8c-6.7-0.1-13.9-5.1-13.9-12.5c0-1.1,0.2-2.2,0.2-2.2
	c0.4-1.8,1.1-3.2,1.7-4.1c-1.5-2.1-2.8-4-3.9-5.8c-4.1-6.7-6.1-12.3-7.3-15.5c-0.6-1.8-1.2-3.3-2-6.4c-0.6-2.1-1.3-5.6-1.3-5.6
	s-1.5-8.9-2.4-15.3c-1.1-8.7-0.3-15.1,0.5-19.2c0.6-2.8,1.2-4.5,2.7-6.2c1.3-1.5,2.7-2.3,3.4-2.7c0.6-0.4,3.2-1.8,7-2.1
	c1.4-0.1,4.1-0.3,7.1,1c0.3,0.1,2.1,0.9,3.8,2.5c0.9,0.8,2.2,2.2,3.8,5.9c0.5,1.2,1.1,2.7,2.3,7.3c0.4,1.4,1.1,4.4,2.2,9.2
	c0.8,3.9,1.3,5.9,1.6,8c0.3,2.3,0.5,4.3,0.8,8.4c0.2,2.8,0.5,6.2,0.5,7.7c0.3,9.5-0.6,17.4-1.6,23.3v0c2.2,0.8,4.1,2.2,5.6,3.8
	c0.2-0.2,0.5-0.4,0.8-0.7c1.3-1,1.9-1.6,2.4-2c1.1-0.9,2.1-1.6,4-3c0.6-0.4,1.1-0.8,1.4-1c-0.8-4.3-1.1-8.1-1.2-11.4
	c0,0-0.3-0.1,4.5-10.2l0,0c5.1-10.5,5.5-20.8,5.1-25.6c-1.3-16.9-17.7-28.6-22.6-31.9c2.8-4.3,5.6-8.7,8.4-13
	c-10.2-3.3-20.5-6.6-30.7-10c-1.2,4.9-2.7,8.7-4,11.4c-1.7,3.7-2.9,6.2-5.4,8.7c-3.2,3.2-5.8,3.7-9.4,5.7C8.2,89.7,4,98.1,3.1,99.9
	c-3.1,6.3-3,11.7-2.8,18C0.6,127.9,3.1,134.7,5.7,142.5z"
    />
    <path
      className="st0"
      d="M69.9,14.9l7.3,2.9C91.5,23.4,98.6,39.7,93,54.1l-6,15.5c-3.6,9.3-13.9,13.9-23.1,10.2l-33-13
	c-9.2-3.6-13.7-14-10.2-23.3l3.2-8.3C31,16.9,51.6,7.8,69.9,14.9L69.9,14.9z"
    />
    <ellipse className="st1" cx="50.9" cy="37" rx="8.3" ry="8.4" />
    <ellipse className="st1" cx="76.1" cy="41.2" rx="6" ry="6.1" />
    <path
      className="st0"
      d="M74.7,9.8l0.4,0.1c1.6,0.5,2.5,2.3,2,4l-6.6,20.2c-0.5,1.6-2.3,2.5-3.9,2l-0.4-0.1c-1.6-0.5-2.5-2.3-2-4
	l6.6-20.2C71.3,10.2,73.1,9.3,74.7,9.8z"
    />
    <ellipse
      transform="matrix(0.9995 -3.107289e-02 3.107289e-02 0.9995 -0.2196 2.3697)"
      className="st0"
      cx="76.1"
      cy="8.3"
      rx="6"
      ry="6"
    />
    <ellipse className="st0" cx="50.9" cy="37" rx="4.8" ry="4.8" />
  </SvgIcon>
)
